const MEDICAL = "Jornada M\u00e9dica";
const NUTRITION = "Jornada de Nutrici\u00f3n";
const COMBINED = "Jornada de Salud/Nutrici\u00f3n";
const SEXUAL = "Jornada de Salud Sexual y Reproductiva";

export function parseActivities(raw) {
  let values = raw;
  if (typeof raw === "string") {
    try { values = JSON.parse(raw); } catch (_) { return []; }
  }
  if (!Array.isArray(values) || !values.every(value => typeof value === "string")) return [];
  return [...new Set(values.map(value => value.trim()).filter(Boolean))];
}

export function classifyActivityCards(raw, catalog = []) {
  const values = new Set(parseActivities(raw));
  const official = (name, id) => Array.isArray(catalog) && catalog.some(entry =>
    entry?.nombre === name && /^[1-9]\d*$/.test(String(entry.id)) && (id === undefined || Number(entry.id) === id));
  return {
    salud: values.has(MEDICAL) || values.has("Telemedicina"),
    nutricion: values.has(NUTRITION) || values.has("Control Nutricional"),
    capacitaciones: values.has("Jornada de Capacitaci\u00f3n"),
    saludNutricion: values.has(COMBINED),
    sexualReproductiva: values.has(SEXUAL),
    nutriV2: values.has(COMBINED) && official(COMBINED, 11),
    anticonV2: values.has(SEXUAL) && official(SEXUAL),
  };
}

export function v2CapturePath(family, id, uuid) {
  if (!["nutrisalud", "anticonceptivos"].includes(family) || !/^[1-9]\d*$/.test(String(id))) return null;
  const query = new URLSearchParams({ convocatoriaId: String(id) });
  if (uuid) query.set("uuid", uuid);
  return `/formularios-v2/${family}?${query}`;
}

export function convocatoriaIdFromSearch(search) {
  const params = new URLSearchParams(search);
  if (params.has("convocatoriaId")) return /^[1-9]\d*$/.test(params.get("convocatoriaId")) ? params.get("convocatoriaId") : null;
  try {
    const id = JSON.parse(params.get("prop"))?.id;
    return /^[1-9]\d*$/.test(String(id)) ? String(id) : null;
  } catch (_) { return null; }
}
